import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ChatMessageSetFollowUpModalUI from './ChatMessageSetFollowUpModalUI.js'

class ChatMessageSetFollowUpModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      toFollowUp: '',
      toFollowUpError: null,
    }
  }

  render() {
    let booleanList = [
      { key: 'true', value: 'Yes' },
      { key: 'false', value: 'No' },
    ]
    return (
      <ChatMessageSetFollowUpModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        toFollowUp={this.state.toFollowUp}
        onToFollowUpChange={(event) => { this.setState({ toFollowUp: event.target.value }) }}
        toFollowUpError={this.state.toFollowUpError}
        setToFollowUpError={(error) => { this.setState({ toFollowUpError: error }) }}
        booleanList={booleanList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    if (this.props.selectedAccountId) {
      RestApiUtils.put(this.props.context,
        `/api/su/accounts/${this.props.selectedAccountId}/chatMessages/${this.props.selectedMesgDate}/toFollowUp`,
          this.onSubmitCallback, {
          toFollowUp: this.state.toFollowUp,
        }
      )
    }

    if (!this.props.selectedAccountId) {
      RestApiUtils.put(this.props.context,
        `/api/su/phoneNumber/${this.props.selectedPhone}/chatMessages/${this.props.selectedMesgDate}/toFollowUp`,
          this.onSubmitCallback, {
          toFollowUp: this.state.toFollowUp,
        }
      )
    }
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 10)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(ChatMessageSetFollowUpModalSF)
